import axios from 'axios';

import Utils from '@/common/utils';

export default {
  search: function (request) {
    return axios.get('/api/mpkProject/search', { params: request });
  },
  find: function (id) {
    return axios.get(`/api/mpkProject/find?id=${id}`);
  },
  update: function (data) {
    if (data.id > 0) return axios.put(`/api/mpkProject/update?id=${data.id}`, data);
    else return axios.post(`/api/mpkProject/create`, data);
  },
  delete: function (id) {
    return axios.delete('/api/mpkProject/delete?id=' + id);
  },
  exportWord: function (request) {
    return Utils.downloadFile('/api/mpkProject/exportWordCard', 'MpkProjectCard.docx', request);
  },
  export: function (request) {
    return Utils.downloadFile('/api/mpkProject/export', '', request);
  },
  createChat: function (data) {
    return axios.post(`/api/mpkProject/CreateChatForProject?projectId=${data.projectId}&orgId=${data.orgId}`);
  },
  getChats: function (id) {
    return axios.get(`/api/mpkProject/getChats?id=${id}`);
  },
  projectsByCountry: function (request) {
    return axios.get('/api/mpkProject/projectsByCountry', { params: request });
  },
  getProjectStatistics: function (request) {
    return axios.get('/api/mpkProject/projectStatistics', { params: request });
  },

  // получение списка наименований МПК, у которых есть связь с Проектами в БД
  getMpkProject: function (params) {
    return axios.get('/api/mpkProject/MpkFromProjects', { params });
  },

  // получение ДИНАМИКА ИЗМЕНЕНИЯ ПОРТФЕЛЯ ПРОЕКТОВ МПК
  getDynamicsChangesProjectPortfolio(params) {
    return axios.get(`/api/mpkprojectanalytic/getyearlydynamicdiagram?${params}`);
  },

  // получение ДИНАМИКА КОЛИЧЕСТВА, СТАТУСОВ, ВКЛЮЧЕНИЯ И ИСКЛЮЧЕНИЯ ПРОЕКТОВ МПК
  getComplexanAlyticDiagram(params) {
    return axios.get('/api/mpkprojectanalytic/getcomplexanalyticdiagram', { params });
  },

  // получение таблицы ДИНАМИКА КОЛИЧЕСТВА, СТАТУСОВ, ВКЛЮЧЕНИЯ И ИСКЛЮЧЕНИЯ ПРОЕКТОВ МПК
  getSearchProjectsForStatistics(params) {
    return axios.get('/api/mpkprojectanalytic/searchprojectsforstatistics', { params });
  },

  // получение КОЛИЧЕСТВО СОЗДАННЫХ РАБОЧИХ МЕСТ
  getNumberJobsCreated(params) {
    return axios.get('/api/mpkprojectanalytic/getemployeenumberhistogram', { params });
  },

  // получение списка заседаний МПК
  getMpkEventMeetingList(params) {
    return axios.get('/api/mpkprojectanalytic/getmpkeventmeetinglist', { params });
  },

  // получение списка государств для графика "Динамика количества, статусов, включения и исключения проектов МПК"
  getProjectMPKCountries() {
    return axios.get('/api/mpkProjectAnalytic/getMpkProjectDynamicCountryList');
  },

  // получение списка МПК для графика "Динамика количества, статусов, включения и исключения проектов МПК"
  getMpkProjectDynamicCommissionList(params) {
    return axios.get('/api/mpkprojectanalytic/getMpkProjectDynamicCommissionList', { params });
  },

  // получение списка мероприятий для графика для графика "Динамика количества, статусов, включения и исключения проектов МПК"
  getMpkProjectDynamicEventList(params) {
    return axios.get('/api/mpkprojectanalytic/getMpkProjectDynamicEventList', { params });
  },

  // получение ПРОЕКТОВ В ПОРТФЕЛЕ МПК
  getProjectsMPKPortfolio(params) {
    return axios.get('/api/mpkprojectanalytic/getsuccessratecirclediagram', { params });
  },

  // получение списка динамики кол-ва квлючения/исключения проектов мпк
  getDynamicModelist() {
    return axios.get('/api/mpkprojectanalytic/getdynamicmodelist');
  },
};
